<template>
  <div class="header">
    <transition name="mobile-menu">
      <div v-if="currentMenuOptions" class="mobile-menu-field col-block width-full" @click="e => currentMenu = null">
        <div class="mobile-menu-container col-block width-full">
          <component
            class="mobile-menu-block col-block"
            v-for="(option, index) in currentMenuOptions"
            :key="index"
            :is="option.to ? 'router-link' : 'div'"
            :to="option.to"
            :class="{ active: option.active }"
            @click.stop="e => { currentMenu = null; (!option.to && option.func()) }"
          >
            <div class="mobile-menu-title">{{ option.title }}</div>
            <div :style="{ flex: 1 }"></div>
          </component>
        </div>
        <div :style="{ flex: 1 }"></div>
      </div>
    </transition>
    <div class="header-field col-block width-full">
      <div class="header-container col-block width-full">
        <div class="header-block row-block">
          <div class="left-container row-block" :style="{ flex: 1 }">
            <router-link v-if="!['mobile'].includes(windowType)" :to="{ name: 'main' }" class="main-logo-container row-block">
              <img :src="require('@/assets/images/main-logo.svg')" alt="" :style="{ width: '166px' }">
            </router-link>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="center-container row-block">
            <span v-if="!['mobile'].includes(windowType)">{{ 'Compass 衛⽣検査所'/* ___ */ }}</span>
            <router-link v-else :to="{ name: 'main' }" class="main-logo-container row-block">
              <img :src="require('@/assets/images/main-logo-mobile.svg')" alt="">
            </router-link>
          </div>
          <div class="right-container row-block" :style="{ flex: 1 }">
            <div :style="{ flex: 1 }"></div>
            <span v-if="!['mobile'].includes(windowType)">{{ '登録番号 | '/* ___ */ }}<a class="link main" :href="'/pdf/第7新保衛医第270号.pdf?v=' + date" target="_blank">{{ '第7新保衛医第270号'/* ___ */ }}</a></span>
            <!-- <template v-if="['mobile'].includes(windowType)">
              <div class="menu-icon-button icon-block" :style="{ '--size': '40px' }" @click="e => currentMenu = (['mobile'].includes(windowType) && !currentMenu ? 'default' : null)">
                <img :src="currentMenu === 'default' ? require('@/assets/icons/menu-close-icon.svg') : require('@/assets/icons/menu-open-icon.svg')" alt="" :style="{ 'max-width': '30px' }">
              </div>
              <div :style="{ width: '20px' }"></div>
            </template>
            <template v-else>
              <component
                class="menu-list-container row-block"
                v-for="(menuOption, moindex) in menuOptions"
                :key="moindex"
                :is="menuOption.to ? 'router-link' : 'div'"
                :to="menuOption.to"
                :class="{ active: menuOption.active }"
                @click="e => (!menuOption.to && menuOption.func())"
              >
                <div class="menu-list-block menu-trigger col-block" :style="{ '--container-width': '100px' }">
                  <div :style="{ flex: 1 }"></div>
                  <div class="menu-list-button row-block">
                    <div class="menu-list-button-text">{{ menuOption.title }}</div>
                  </div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div :style="{ flex: 1 }"></div>
              </component>
            </template> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import responsitiveData from '@/mixins/responsitiveData.vue'
import { dateFormat } from '@/constants/global/util'

export default {
  mixins: [
    responsitiveData
  ],
  data () {
    return {
      currentMenu: null,
      date: dateFormat(new Date(), 'yyyyMMddhhmmss')
    }
  },
  computed: {
    currentMenuOptions () {
      let currentMenuOptions = {
        'default': this.menuOptions
      }[this.currentMenu]
      return currentMenuOptions
    },
    // static
    menuOptions () {
      return [
      ]
    }
  },
  watch: {
    '$route' () {
      this.currentMenu = null
    }
  },
  methods: {
    ...mapActions([
      'setMainSectionAction'
    ]),
    gotoSection (id) {
      this.setMainSectionAction(id)
    }
  }
}
</script>
